<div class="stepper--wrapper" [formGroup]="data.formGroup" *ngIf="isComplete">
  <nx-multi-stepper
    [linear]="true"
    currentStepLabel="Step"
    (selectionChange)="onSelectionChange($event)"
    [(selectedIndex)]="currentStep"
  >
    <ng-container *ngFor="let step of data.formData.form; let i = index">
      <nx-step
        [label]="step.title | translate"
        (interacted)="onInteracted($event)"
        [stepControl]="data.formGroup.controls[step.name] || ''"
      >
        <ng-container *ngIf="currentStep === i">
          <app-form
            [data]="{
              formData: {
                form: step.step,
                submit: data.formData.submit,
                back: data.formData.back,
              },
              formGroup: data.formGroup.controls[step.name],
              stepName: step.name,
            }"
            [isStep]="true"
            [isLastStep]="currentStep === data.formData.form.length - 1"
            (stepClick)="onStepClick(currentStep + $event)"
          ></app-form>
        </ng-container>
      </nx-step>
    </ng-container>
  </nx-multi-stepper>
</div>
